<h2 mat-dialog-title>
  <mat-icon>table_chart</mat-icon>
  {{ 'Sftp.Upload.SpreadsheetPreview.Title' | translate: locale.language }}
</h2>

<mat-dialog-content>
  @if (loading()) {
    <div class="loading-state">
      <mat-spinner diameter="40"></mat-spinner>
      <p>{{ 'Sftp.Upload.SpreadsheetPreview.Loading' | translate: locale.language }}</p>
    </div>
  } @else if (error()) {
    <div class="error-state">
      <mat-icon color="warn">error_outline</mat-icon>
      <p>{{ error() }}</p>
    </div>
  } @else if (spreadsheetData()) {
    <div class="preview-info">
      <div class="info-item">
        <mat-icon>description</mat-icon>
        <span>{{ data.file.name }}</span>
      </div>
      <div class="info-item">
        <mat-icon>grid_on</mat-icon>
        <span
          >{{ spreadsheetData()!.totalRows | number }} {{ 'Sftp.Upload.SpreadsheetPreview.Rows' | translate: locale.language }}</span
        >
      </div>
      @if (spreadsheetData()!.truncated) {
        <mat-chip class="truncated-chip">
          <mat-icon>visibility</mat-icon>
          {{ 'Sftp.Upload.SpreadsheetPreview.ShowingFirst' | translate: locale.language }} {{ data.maxPreviewRows || 100 }}
        </mat-chip>
      }
    </div>

    <div class="table-container">
      <table mat-table [dataSource]="spreadsheetData()!.rows" class="spreadsheet-table">
        <!-- Row Number Column -->
        <ng-container matColumnDef="rowNumber">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let row; let i = index">{{ i + 1 }}</td>
        </ng-container>

        <!-- Dynamic Columns -->
        @for (header of spreadsheetData()!.headers; let colIndex = $index; track colIndex) {
          <ng-container [matColumnDef]="'col' + colIndex">
            <th mat-header-cell *matHeaderCellDef>
              <div class="header-content">
                <span class="column-letter">{{ getColumnLabel(colIndex) }}</span>
                <span class="column-name">{{ header }}</span>
              </div>
            </th>
            <td mat-cell *matCellDef="let row" [title]="row[colIndex]">
              {{ row[colIndex] }}
            </td>
          </ng-container>
        }

        <tr mat-header-row *matHeaderRowDef="getDisplayedColumns()"></tr>
        <tr mat-row *matRowDef="let row; columns: getDisplayedColumns()"></tr>
      </table>
    </div>

    @if (spreadsheetData()!.truncated) {
      <mat-card class="truncation-notice" appearance="outlined">
        <mat-card-content>
          <mat-icon>info_outline</mat-icon>
          <span>
            {{
              'Sftp.Upload.SpreadsheetPreview.TruncationMessage'
                | translate: locale.language : { count: data.maxPreviewRows || 100, total: spreadsheetData()!.totalRows }
            }}
          </span>
        </mat-card-content>
      </mat-card>
    }
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="close()" style="margin-top: 1rem">
    {{ 'Close' | translate: locale.language }}
  </button>
</mat-dialog-actions>
